import gql from "graphql-tag";

export const GetOpportunityDetails = gql`
  query GetOpportunities($id: String) {
    opportunities(opportunity: { id: $id }) {
      id
      visibility
      isPercentage
      isActive
      expiresAt
      isApplicable
      amount

      applicants{
        account {
          id
        }
        applicationEvents{
          status
        }
      }

      product {
        id
        name
        price
        description
        isDonation
        images {
          id
          url
        }
        owner {
          id
          name
          picture
          bio
          website
          createdAt
          preference {
            headingColor
            textColor
            backgroundColor
            backgroundImage
            brandLogo
          }
        }
      }
    }
  }
`;
